import { InputSelect, InputWrapper } from '@vrplatform/components';
import { Icon } from '@vrplatform/icons';
import { Box, Checkbox } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Controller, useWatch } from 'react-hook-form';
import { useTaxRatesQuery } from '@vrplatform/data';
import { TaxRateModal } from '../../../settings/tax-rates/TaxRateModal';
import { useFeeForm } from '../useFeeForm';

export const FeeTaxRateEditor = () => {
  const methods = useFeeForm();

  const [openedAddTaxRate, handlersAddTaxRate] = useDisclosure(false);

  const showTaxIncludedCheckbox = !!useWatch({
    control: methods.control,
    name: 'taxRateId',
  });

  const { data: rates, isLoading, error } = useTaxRatesQuery();

  return (
    <>
      <TaxRateModal
        closeModal={handlersAddTaxRate.close}
        opened={openedAddTaxRate}
      />

      <Controller
        control={methods.control}
        name={'taxRateId'}
        render={({ field, fieldState }) => {
          const value = rates?.find((x) => x.value === field.value) || null;

          return (
            <InputWrapper error={fieldState.error?.message}>
              <InputSelect
                type="single"
                value={value}
                setValue={(value) => {
                  field.onChange(value?.value || null);
                  const behavior = methods.getValues('taxRateBehavior');
                  if ((!behavior || behavior === 'excluded') && value?.value) {
                    methods.setValue('taxRateBehavior', 'included', {
                      shouldDirty: true,
                      shouldTouch: true,
                      shouldValidate: true,
                    });
                  }
                }}
                inputProps={{
                  loadingQuery: isLoading,
                  error: !!fieldState.error,
                  placeholder: 'Select tax rate',
                  withClearButton: true,
                  disabled: field.disabled,
                }}
                customBottomActions={[
                  {
                    id: 'add-tax-rate',
                    label: 'Other Rate - Add tax rate',
                    description: 'If you are missing a tax rate, add it now.',
                    onSubmit: () => handlersAddTaxRate.open(),
                    icon: <Icon icon="PlusIcon" size={16} />,
                  },
                ]}
                data={{
                  options: rates || [],
                  error,
                  loading: isLoading,
                }}
              />
            </InputWrapper>
          );
        }}
      />

      {/* Collapse wrapper */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'auto',
          maxHeight: showTaxIncludedCheckbox ? '30px' : 0,
          overflow: 'hidden',
          transition: 'max-height 0.3s ease-in-out',
        }}
      >
        <InputWrapper title="" mt="xs">
          <Controller
            control={methods.control}
            name={'taxRateBehavior'}
            render={({ field, fieldState }) => {
              return (
                <InputWrapper error={fieldState.error?.message}>
                  <Checkbox
                    checked={field.value === 'included'}
                    label="Include tax in applied amount"
                    onChange={(event) =>
                      field.onChange(
                        event.currentTarget.checked ? 'included' : 'excluded'
                      )
                    }
                    size="xs"
                    disabled={field.disabled}
                    sx={(theme) => ({
                      flex: 1,
                      width: 250,
                      color: theme.colors.neutral[8],
                    })}
                  />
                </InputWrapper>
              );
            }}
          />
        </InputWrapper>
      </Box>
    </>
  );
};
